import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
    max-width: 1400px;
    margin: 0 auto;
`

const StandardWrapper = ({ children }) => (
    <Container>
        {children}
    </Container>
)

export default StandardWrapper


// WEBPACK FOOTER //
// ./src/components/standardWrapper.js